import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.Intro.heading',
    defaultMessage: 'Nasze spółki:'
  }
});



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Intro/Intro.intl.js